export default __webpack_public_path__ + "fdedc0a2cea2dcfe5bf4bc2c8d417433.svg";